import { STATUSES, normalizeStatus } from '../api/contentApi';

export default function StatusBadge({ status }) {
  const value = normalizeStatus(status);
  const label = STATUSES.find((s) => s.value === value).label;
  return <span className={`badge badge-${value}`}>{label}</span>;
}
